import { BaseControl, ControlPosition } from "./BaseControl.js";
import { Pano } from "../Pano.js";
import { Resource } from "../../model/Resource.js";
import { Language } from "../../model/Language.js";

export class ControlEdit extends BaseControl {

    constructor(pano: Pano) {
        super(pano);

        this.pano.addButton(
            {
                icon: "fal fa-pen",
                position: ControlPosition.RIGHT,
                tooltip: Language.resolve("Im Backend öffnen", "Open in backend"),
                onInit: (item) => {
                    pano.onChangeVideo.add((video) => {
                        item.visible = !!this.pano.current;
                    });
                },
                onClick: (item) => {
                    if (this.pano.current){
                        window.open(Resource.SITE + "/wp-admin/post.php?post=" + this.pano.current.id + "&action=edit", "_pano-edit");
                    }
                }
            }
        );
    }
}